import { Component } from 'react';

import { api, removeToken } from '../../../utils/api';

class Logout extends Component {
  componentWillMount() {
    api.post('/auth/logout').then(() => {
      removeToken();

      // After clearing the token, go to the root page
      window.location.href = '/';
    });
  }

  render() {
    return null;
  }
}

export default Logout;
